import { TFunction } from 'react-i18next'
import { LanguagePreferenceEnum } from 'models/LanguagePreference'
import { z } from 'zod'
import { createAccountSettingsEmailSchema, emailEmptyErrorArgs } from './common-schemas'

export const createSchema = (t: TFunction) => (
  createAccountSettingsEmailSchema(t).and(
    z.object({
      isEmailPreferred: z.string(),
      language: LanguagePreferenceEnum
    })
  ).refine(
    (d) => d.isEmailPreferred !== 'true' || d.email,
    emailEmptyErrorArgs(t)
  )
)

export type MsnSettingsForm = z.infer<ReturnType<typeof createSchema>>
